/*
  @attributes:
    - events: event handlers (event_name, function) which are triggered by any RPC call to sendEvent
    - config: the configuration Object for XDM RPC (see easyXDM)
    - jsonRpcConfig: the definitions Object for any RPC method call (see easyXDM)
  @methods:
    - xdHandler: retrieve or initialize a XDM RPC handler
*/
define('rpc',["utils/constants", "runtime", "easyXDM/easyXDM"], function(CONST, Runtime, XDM){
  var RPC = {
    events: {}
  };
  var config = {};
  var jsonRpcConfig = {
    local: {
      sendEvent: function(event_name) {
        var event_handler = RPC.events[event_name];
        if (event_handler){
          var args = Array.prototype.slice.call(arguments, 1);
          event_handler.apply({}, args);
        }
      }
    }
  };

  var __handler = null;
  // NameTransport for current domain
  if (Runtime.channelUrl) {
    config.local = Runtime.channelUrl;
  }
  // NameTransport for id.net domain
  config.remoteHelper = CONST.name_helper_url;
  config.remote = CONST.xd_handler_helper_url;
  config.channel = 'id_xd_api';

  RPC.config = config;
  RPC.jsonRpcConfig = jsonRpcConfig;

  RPC.xdHandler = function() {
    if (__handler === null) {
      __handler = new XDM.Rpc(config,jsonRpcConfig);
    }
    return __handler;
  };

  return RPC;
});

